<template>
  <tbody>
      <tr v-if="!datas">
          <td colspan="9">加载中......</td>
      </tr>
      <template v-if="datas && datas.length">
          <tr v-for="(data, index) in datas" :key="index" :class="[isStock ? `star${data.star}` : (data.star > 2 ? 'important' : '')]">
              <td class="ushk-rili_content-time">{{ data.time_show }}</td>
              <td class="ushk-table_rowspan ushk-rili_content-country">
                  <img :src="`//cdn.jin10.com/assets/img/commons/flag/${data.country}.png`" width="24" height="16" border="0">
              </td>
              <td>
                  <p class="ushk-table_alignLeft">
                      {{ data.title }}
                      <!-- <a v-if="data.readButton.show" class="ushk-rili_readButton" :href="data.readButton.link" target="_blank">阅读</a> -->
                  </p>
              </td>
              <td>
                <star :width="data.star"/>
              </td>
              <td>
                <div v-if="data.revised" class="ushk-rili_content-previous">
                  {{ data.revised }}
                  <span>修正前<br/>
                  <template v-if="data.previous !== null && data.previous !== ''">
                      {{ moneyUnit(data.unit) }}{{ data.previous }}{{ data.unit === '%' ? data.unit : '' }}
                  </template>
                  <template v-else>
                    ---
                  </template>
                  </span>
                </div>
                <template v-else>
                  <template v-if="data.previous !== null && data.previous !== ''">
                      {{ moneyUnit(data.unit) }}{{ data.previous }}{{ data.unit === '%' ? data.unit : '' }}
                  </template>
                  <template v-else>
                    ---
                  </template>
                </template>
              </td>
              <td>
                <template v-if="data.consensus !== null && data.consensus !== ''">
                    {{ moneyUnit(data.unit) }}{{ data.consensus }}{{ data.unit === '%' ? data.unit : '' }}
                </template>
                <template v-else>
                  ---
                </template>
              </td>
              <td>
                  <div :id="data.id">
                    <template v-if="data.actual !== null &&data.actual !== ''">
                      {{ moneyUnit(data.unit) }}{{ data.actual }}{{ data.unit === '%' ? data.unit : '' }}
                    </template>
                    <template v-else>
                      未公布
                    </template>
                  </div>
              </td>
              <td :id="`J_${data.id}`">
                  <div class="ushk-tag_trend" v-if="data.show_affect && data.country !== '中国'">
                      <p :class="data.status_class ? data.status_class : 'default'">
                          <span class="ushk-btn J_kind_tag" data-trend="1">
                            <em v-if="data.status_name === '未公布'" class="J_kind_trend">---</em>
                            <template v-else>
                              <em class="J_kind_trend">{{ data.status_name }}</em>
                                <i  class="J_kind_trendType">{{data.status_name ==='影响较小' ? ' ': '股票'}} </i>
                            </template>
                          </span>
                      </p>
                  </div>
              </td>
          </tr>
      </template>
      <tr v-else>
          <td colspan="9">{{ noneText }}</td>
      </tr>
  </tbody>
</template>

<script>
  export default {
    props: {
      datas: {
        type: [Array, Boolean],
        default: false
      },
      noneText: {
        type: String,
        default: '今日无重要经济数据'
      },
      type: String
    },
    computed: {
      isStock () {
        return this.type.indexOf('stock') !== -1
      }
    },
    data () {
      return {
      }
    },
    methods: {
      moneyUnit (unit) {
        return this.isStock && unit !== '%' ? unit : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EconomicsList.vue?6bfbf3f8